import CityPageTemplate from "../city-template/CityPageTemplate";
import { corpusChristiConfig } from "./data";

export default function CorpusChristiPage() {
  return <CityPageTemplate config={corpusChristiConfig} />;
}